// config.js
// export const API_BASE_URL = 'https://finwise-backend.vercel.app/account';
export const API_BASE_URL = 'https://finwise-backend.vercel.app';
